import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAddProviderPhotos,
  fetchProviderPhotosList,
  fetchProviderProfilePhoto,
} from "./ProviderPhotosActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const ProviderPhotosList = createSlice({
  name: "ProviderPhotosList",
  initialState: {
    photosLoading: false,
    photosData: [],
    photosError: null,
  },
  reducers: {
    updateProviderPhotosList: (state, action) => {
      console.log(action.payload);
      state.photosData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderPhotosList.pending, (state) => {
        state.photosLoading = true;
        state.photosError = null;
      })
      .addCase(fetchProviderPhotosList.fulfilled, (state, action) => {
        // state.photosLoading = false;
        // state.photosData = action.payload?.data?.data?.mediaItemResponseDTO;
        state.isProviderOverviewDataLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.photosError = false;
            state.photosData = [];
          } else {
            state.photosError = true;
            state.providerOverviewErrorMsg = getApiErrorMessage(
              action.payload.status
            );
          }
        } else {
          state.photosError = false;
          state.photosData = action.payload?.data?.data?.mediaItemResponseDTO;
        }
      })
      .addCase(fetchProviderPhotosList.rejected, (state, action) => {
        state.photosLoading = false;
        state.photosError = action.error.message;
      });
  },
});

const ProviderProfilePhoto = createSlice({
  name: "ProviderProfilePhoto",
  initialState: {
    profilePhotosLoading: false,
    profilePhto: [],
    profilePhotoError: null,
  },
  reducers: {
    addProfilePhotoReducer: (state, action) => {
      state.profilePhto = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderProfilePhoto.pending, (state) => {
        state.profilePhotosLoading = true;
        state.profilePhotoError = null;
      })
      .addCase(fetchProviderProfilePhoto.fulfilled, (state, action) => {
        state.profilePhotosLoading = false;
        state.profilePhto = action.payload?.data?.data?.mediaItemResponseDTO;
        // state.profilePhto = action.payload;
      })
      .addCase(fetchProviderProfilePhoto.rejected, (state, action) => {
        state.profilePhotosLoading = false;
        state.profilePhotoError = action.error.message;
      });
    builder
      .addCase(fetchAddProviderPhotos.pending, (state) => {
        state.profilePhotosLoading = true;
        state.profilePhotoError = null;
      })
      .addCase(fetchAddProviderPhotos.fulfilled, (state, action) => {
        state.profilePhotosLoading = false;
        if (!action.payload.success) {
          state.profilePhotoError = true;
          state.lngErrorMsg = getApiErrorMessage(action.payload.status);
        }
      })
      .addCase(fetchAddProviderPhotos.rejected, (state, action) => {
        state.profilePhotosLoading = false;
        state.profilePhotoError = action.error.message;
      });
  },
});

export const { updateProviderPhotosList } = ProviderPhotosList.actions;

export const photosListReducer = ProviderPhotosList.reducer;
export const providerProfilePhotoReducer = ProviderProfilePhoto.reducer;
